import { useEffect, useState } from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Chip,
  DataGrid,
} from "..";
import { ProdutosService } from "../../services";
import { formatPrice, responseErros } from "../../utils";
import shortid from "shortid";
import { value } from "../../helpers";

const ProdutoEstoqueInformacaoDialog = ({
  produto,
  open,
  setOpen,
  usuario,
}) => {
  const [produtoEstoqueInformacao, setProdutoEstoqueInformacao] = useState([]);
  const produtosService = new ProdutosService();

  const colunasEstoqueInformacao = [
    {
      field: "empresaId",
      headerName: "Empresa",
      flex: 600,
      valueGetter: (params) => {
        if (!usuario.acessosEmpresas?.length) return "";
        return value.autoComplete(usuario.acessosEmpresas, params.value)
          ?.fantasia;
      },
    },
    {
      field: "estoque",
      headerName: "Estoque",
      headerAlign: "center",
      align: "center",
      flex: 150,
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      headerAlign: "center",
      align: "center",
      flex: 250,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "bairro",
      headerName: "Bairro",
      headerAlign: "center",
      align: "center",
      flex: 300,
      valueGetter: (params) => {
        if (!usuario.acessosEmpresas?.length) return "";
        return value.autoComplete(usuario.acessosEmpresas, params.row.empresaId)
          ?.bairro;
      },
    },
    {
      field: "cidade",
      headerName: "Cidade",
      headerAlign: "center",
      align: "center",
      flex: 300,
      valueGetter: (params) => {
        if (!usuario.acessosEmpresas?.length) return "";
        return value.autoComplete(usuario.acessosEmpresas, params.row.empresaId)
          ?.cidade;
      },
    },
  ];

  useEffect(() => {
    if (open) {
      buscarEstoqueInformacaoProduto();
    }
  }, [open]);

  function buscarEstoqueInformacaoProduto() {
    if (!produto.id) onClose();
    produtosService
      .getByIdProdutoEstoqueInformacaoEmpresas(produto.id)
      .then((result) => {
        if (!result.isAxiosError) {
          if (result.data?.length) {
            setProdutoEstoqueInformacao(
              result.data.map((r) => ({ ...r, id: shortid.generate() }))
            );
          }
        } else {
          responseErros(result);
        }
      });
  }

  function onClose() {
    setOpen(false);
  }

  return (
    <Dialog fullWidth maxWidth={"xl"} open={open} onClose={() => onClose()}>
      <DialogContent>
        <Grid item xs={12}>
          <h6 className="text-uppercase fw-bold pt-2">
            Produto Estoque | Informação
          </h6>
          <Chip
            label={`${produto?.codigo} - ${produto?.descricao}`}
            className="mt-2 mb-4"
            color={"success"}
            sx={{
              borderRadius: "4px",
              height: "25px",
              clipPath: `polygon(0% 0%, calc(100% - 10px) 0%, 100% 50%, calc(100% - 10px) 100%, 10px 100%, 0% 100%)`,
              "& .MuiChip-label": {
                fontWeight: "600",
                fontSize: "13px",
                paddingRight: 4,
                letterSpacing: ".2px",
              },
            }}
          />
        </Grid>
        <DataGrid
          rows={produtoEstoqueInformacao}
          columns={colunasEstoqueInformacao}
          rowCount={produtoEstoqueInformacao?.length}
          disableAcoes
        />
      </DialogContent>
      <DialogActions className="me-3">
        <Button onClick={() => onClose()} color="padrao" variant="contained">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProdutoEstoqueInformacaoDialog;
